<template>
  <div>
    <div class="row mb-2">
      <div class="col-12">
        <page-header :actions="headerActionsConfig" :page="headerConfig" />
      </div>
    </div>
    <div v-if="!isReadOnly" class="container-fluid">
      <ValidationObserver ref="formContractTemplateRef">
        <div class="row">
          <div class="col-12 col-md-4">
            <validation-provider v-slot="{ errors }" :rules="'required'">
              <custom-drop-down
                id="contract-document-configuration-management-academic-year-drop-down"
                v-model="model.academicYear"
                :custom-error-msg="'El año académico es requerido.'"
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Año Académico:"
                :options="collections.academicYears"
                placeholder="Seleccione"
              />
            </validation-provider>
          </div>
          <div class="col-12 col-md-8">
            <label class="data-title mb-0">Estatus:</label>
            <div class="d-flex">
              <span
                :class="
                  `dot color-dot-${getContractTemplateStatusColor(
                    model.statusId
                  )} mr-1 mt-1`
                "
              />
              <p class="font-16">{{ model.statusName | empty }}</p>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-12">
            <validation-provider
              v-slot="slotProps"
              rules="contractTemplateTypeRequired"
            >
              <chips-selection
                v-model="model.contractTypes"
                :chips-config="chipsConfig"
                :errors="slotProps.errors"
                selected-items-title="Servicio(s) Seleccionado(s):"
                @addingItem="addingContractType"
              >
                <template #selectionInputs>
                  <validation-observer ref="contractTypeForm" disabled>
                    <div class="form-group">
                      <validation-provider v-slot="{ errors }" rules="required">
                        <custom-drop-down
                          id="contract-document-dropdown-contractType"
                          v-model="selectedContractType"
                          custom-error-msg="El tipo de contrato es requerido."
                          :error="errors[0]"
                          fieldkey="id"
                          fieldname="name"
                          label="Tipo de Contrato:"
                          :options="availableContractTypeOptions"
                          placeholder="Seleccione"
                        />
                      </validation-provider>
                    </div>
                  </validation-observer>
                </template>
              </chips-selection>
            </validation-provider>
          </div>
        </div>
        <div class="row border-top mt-4">
          <div
            class="col-12 mt-4"
            :class="!isMobile ? 'd-flex justify-content-end' : ''"
          >
            <custom-drop-down
              id="contract-document-dropdown-field"
              v-model="fieldSelected"
              :class="isMobile ? '' : 'col-3'"
              :clearable="false"
              fieldkey="id"
              fieldname="name"
              :options="fields"
              placeholder="Seleccione"
            />
            <action-button
              id="contract-document-add-field"
              :class="isMobile ? 'col-12 mt-2' : 'ml-2'"
              :disabled="!fieldSelected"
              i="fas fa-copy"
              text="Copiar Campo"
              variant="outline-success pl-4 pr-4"
              @click="() => this.copyFieldHandler()"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 mt-2">
            <label class="input-label" for="">Mensaje:</label>
            <validation-observer ref="messageValidation" disabled>
              <validation-provider
                v-slot="{ errors, classes }"
                :custom-messages="{
                  contractTemplateRequired: 'El mensaje es requerido.',
                }"
                name="messageEditor"
                rules="contractTemplateRequired"
              >
                <custom-vue-editor
                  id="contract-document-configuration-management-message"
                  v-model="model.message"
                  :class="{ 'was-Invalidated': classes.invalid }"
                  :error="errors[0]"
                />
                <Error
                  v-if="errors[0] && errors[0].length > 0"
                  :message="errors[0]"
                  variant="no-border"
                />
              </validation-provider>
            </validation-observer>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-3 offset-md-9 mt-3 text-right">
            <action-button
              id="contract-document-preliminary-view"
              :disabled="!model.message"
              i="fas fa-search-plus"
              text="Vista Preliminar"
              variant="success pl-4 pr-4"
              @click="showModalOpen()"
            />
          </div>
        </div>
      </ValidationObserver>
    </div>
    <div v-else class="container-fluid">
      <div class="row">
        <div class="col-12 col-md-3">
          <span class="data-title d-block border-mobile">Año Académico:</span>
          <span class="font-16 color-black">
            {{ model.academicYear.name }}
          </span>
        </div>
        <div class="col-12 col-md-9">
          <label class="data-title mb-0">Estatus:</label>
          <div class="d-flex">
            <span
              :class="
                `dot color-dot-${getContractTemplateStatusColor(
                  model.statusId
                )} mr-1 mt-1`
              "
            />
            <p class="font-16">{{ model.statusName | empty }}</p>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <span class="col-12 data-title d-block border-mobile">
          Servicio(s) Seleccionado(s):
        </span>
        <div class="col-12">
          <chips-selection
            v-model="model.contractTypes"
            :chips-config="chipsConfig"
            :disabled="true"
            selected-items-title="Servicio(s) Seleccionado(s):"
          />
        </div>
      </div>
      <div class="row border-top mt-4">
        <div class="col-md-12 mt-4">
          <span class="data-title d-block border-mobile">Mensaje:</span>
          <CustomCallout
            class="message-border"
            :has-border="false"
            :has-toggle="false"
          >
            <div v-html="model.message" />
          </CustomCallout>
        </div>
      </div>
    </div>
    <custom-modal
      cancel-text="Cancelar"
      class="custom-icon-color"
      icon="fas fa-search-plus "
      icon-color="#2db782"
      is-centered
      :show-cancel="false"
      :show-save="false"
      title="Vista Preliminar"
      :value="showModal"
      width="900px"
      @cancel="cancelModal"
    >
      <div
        class="scroll ml-3 mr-3 container-html pl-2 pt-2"
        v-html="model.message"
      />
      <div class="row mt-3">
        <div class="col-12 d-flex justify-content-center">
          <action-button
            id="close-button-modal"
            i="fas fa-times-circle"
            text="Cerrar"
            variant="outline-danger pl-4 pr-4"
            @click="cancelModal"
          />
        </div>
      </div>
    </custom-modal>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import PageHeader from 'PageHeader';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import store, { modulesName } from '@/store/index';
import CustomModal from 'CustomModal';
import {
  requestinfo as _requestinfo,
  getContractFields as _getContractFields,
  detail as _detail,
  saveOrUpdateContractTemplate as _saveOrUpdateContractTemplate,
  updateStatus as _updateStatus,
  downloadTemplate as _downloadTemplate,
} from '@/services/provider/contract-document-configuration.api.js';
import contractTemplateStatus, {
  getContractTemplateStatusColor as _getContractTemplateStatusColor,
} from '@/utils/constants/contractTemplateStatus';
import ChipsSelection from '@/components/common/ChipsSelection';
import CustomVueEditor from '@/components/common/CustomVueEditor';
import CustomCallout from 'custom-callout';
import Error from 'custom-error';

export default {
  name: 'ContractDocumentConfigurationManagement',
  components: {
    PageHeader,
    ValidationObserver,
    ValidationProvider,
    CustomDropDown,
    ActionButton,
    ChipsSelection,
    CustomVueEditor,
    CustomCallout,
    CustomModal,
    Error,
  },
  mixins: [alertMixin],
  data: () => ({
    showModal: false,
    messageEditor: null,
    collections: {
      academicYears: [],
      contractTypes: [],
    },
    fields: [],
    model: {
      contractTemplateId: null,
      academicYear: null,
      contractTypes: [],
      statusId: null,
      statusName: null,
      message: null,
    },
    fieldSelected: null,
    chipsConfig: [{ labelText: '', valueProp: 'name' }],
    selectedContractType: null,
  }),
  computed: {
    headerConfig() {
      return {
        icon: 'fas fa-user-tie',
        title: 'Configuración de Documento de Contrato',
        routes: [
          'Inicio',
          'Proveedores',
          'Configuración de Documento de Contrato',
        ],
      };
    },
    isMobile() {
      return store.getters[`${modulesName.appModuleName}/getIsMobileDensity`];
    },
    availableContractTypeOptions() {
      const data = this.collections.contractTypes.filter(
        (a) => !this.model.contractTypes?.some((e) => e.id == a.id)
      );
      return data;
    },
    contractTemplateId() {
      return (
        +this.$route.params.contractTemplateId ||
        this.model.contractTemplateId ||
        null
      );
    },
    isReadOnly() {
      return (
        Boolean(this.contractTemplateId) &&
        this.model.statusId == contractTemplateStatus.Publicado
      );
    },
    headerActionsConfig() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left fa-fw',
          variant: 'outline-success',
          click: () => this.$router.go(-1),
        },
        {
          text: 'Imprimir',
          icon: 'fas fa-print pr-2',
          visible: this.canShowPrintAction,
          variant: 'outline-success',
          click: () => this.print(),
        },
        {
          text: 'Guardar',
          icon: 'fas fa-save pr-2',
          visible: !this.isReadOnly,
          variant: 'outline-success',
          click: () => this.saveOrUpdateHandler(),
        },
        {
          text: 'Publicar',
          visible: this.canShowPublishAction,
          icon: 'fas fa-check-double pr-2',
          variant: 'success',
          click: () => this.publish(),
        },
        {
          text: 'Cambiar a Borrador',
          visible: this.canShowDraftAction,
          icon: 'fas fa-eraser pr-2',
          variant: 'success',
          click: () => this.draft(),
        },
      ];
    },
    canShowPrintAction() {
      return (
        Boolean(this.contractTemplateId) &&
        (this.model.statusId == contractTemplateStatus.Borrador ||
          this.model.statusId == contractTemplateStatus.Publicado)
      );
    },
    canShowPublishAction() {
      return (
        Boolean(this.contractTemplateId) &&
        this.model.statusId == contractTemplateStatus.Borrador
      );
    },
    canShowDraftAction() {
      return (
        Boolean(this.contractTemplateId) &&
        this.model.statusId == contractTemplateStatus.Publicado
      );
    },
    getText() {
      return this.model.message;
    },
    contractTypes() {
      return this.model.contractTypes;
    },
  },
  async mounted() {
    await this.onLoad();
  },
  watch: {
    contractTypes: {
      immediate: true,
      async handler(val) {
        try {
          const ids = val.map((s) => s.id);
          const { data } = await _getContractFields(ids);
          this.fields = data;
        } catch (err) {
          this.ShowToast('', err.response?.data?.message, 'error');
        }
      },
    },
  },
  methods: {
    cancelModal() {
      this.showModal = false;
    },
    acceptView() {
      this.showModal = false;
    },
    showModalOpen() {
      this.showModal = true;
    },
    async onLoad() {
      await Promise.all([this.getRequestInfo(), this.getDetailInfo()]);
    },
    getContractTemplateStatusColor(contractTemplateStatusId) {
      return _getContractTemplateStatusColor(contractTemplateStatusId);
    },
    async getRequestInfo() {
      const { data } = await _requestinfo();
      this.collections = data.collections;
    },
    async getDetailInfo() {
      if (!this.contractTemplateId) {
        this.model.statusId = contractTemplateStatus.Borrador;
        this.model.statusName = 'Borrador';
        return;
      }

      const { data } = await _detail(this.contractTemplateId);
      this.fields = data.fields;

      this.model = data;
    },
    async addingContractType() {
      var passed = await this.$refs.contractTypeForm.validate();

      if (
        (this.selectedContractType?.id === 1 ||
          this.selectedContractType?.id === 2) &&
        this.model.contractTypes?.some((e) => e.id == 4)
      ) {
        passed = false;
        this.ShowToast(
          'Alerta',
          'No es posible realizar la configuración para los tipos de servicios seleccionados.',
          'error'
        );
      }

      if (
        this.selectedContractType?.id === 4 &&
        this.model.contractTypes?.some((e) => e.id == 1 || e.id == 2)
      ) {
        passed = false;
        this.ShowToast(
          'Alerta',
          'No es posible realizar la configuración para los tipos de servicios seleccionados.',
          'error'
        );
      }

      if (passed) {
        const contractTypeToAdd = { ...this.selectedContractType };
        this.selectedContractType = null;

        this.$refs.contractTypeForm.reset();
        return contractTypeToAdd;
      }
    },
    copyFieldHandler() {
      navigator.clipboard.writeText(`{{${this.fieldSelected.name}}}`);
    },
    async saveOrUpdateHandler() {
      const isValid = await this.$refs.formContractTemplateRef.validate();
      if (!isValid) {
        this.ShowToast('Alerta', 'Información Incompleta', 'error');
        return;
      }

      if (this.model.contractTypes.length == 0) {
        this.ShowToast(
          'Alerta',
          'Debe agregar al menos un tipo de contrato',
          'error'
        );
        return;
      }

      const contractTypes = this.model.contractTypes.map((s) => s.id);
      const payload = {
        contractTemplateId: this.model.contractTemplateId,
        academicYearId: this.model.academicYear.id,
        contractTypes: contractTypes,
        message: this.model.message,
      };

      await _saveOrUpdateContractTemplate(payload)
        .then((res) => {
          this.model.contractTemplateId = res.data.contractTemplateId;
          this.ShowToast(
            'Proceso exitoso.',
            'La información se ha guardado exitosamente.',
            'success'
          );
        })
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error');
        });
    },
    print() {
      if (this.model.contractTemplateId) {
        return _downloadTemplate(this.model.contractTemplateId);
      } else {
        this.ShowToast(
          'Alerta',
          'Guarde la configuración de contrato para imprimir.',
          'error'
        );
      }
    },
    async publish() {
      const isValidContract = await this.$refs.formContractTemplateRef.validate();
      const isValidMessage = await this.$refs.messageValidation.validate();

      if (!(isValidContract && isValidMessage)) {
        this.ShowToast('Alerta', 'Información Incompleta', 'error');
        return;
      }

      if (this.model.contractTypes.length == 0) {
        this.ShowToast(
          'Alerta',
          'Debe agregar al menos un tipo de contrato',
          'error'
        );
        return;
      }

      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro(a) que desea publicar el documento de contrato configurado?`,
        'Sí',
        'No'
      );
      if (!answer) return;

      const contractTypes = this.model.contractTypes.map((s) => s.id);
      const payload = {
        contractTemplateId: this.model.contractTemplateId,
        academicYearId: this.model.academicYear.id,
        contractTypes: contractTypes,
        message: this.model.message,
      };

      await _saveOrUpdateContractTemplate(payload)
        .then((res) => {
          this.model.contractTemplateId = res.data.contractTemplateId;

          _updateStatus(
            this.model.contractTemplateId,
            contractTemplateStatus.Publicado
          )
            .then((res) => {
              if (res.data) {
                this.model.statusId = res.data.statusId;
                this.model.statusName = res.data.statusDescription;
              }
              this.ShowToast(
                'Proceso exitoso.',
                'El documento ha sido publicado exitosamente.',
                'success'
              );
            })
            .catch((err) => {
              this.ShowToast('', err.response?.data?.message, 'error');
            });
        })
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error');
        });
    },
    async draft() {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro(a) que desea cambiar a borrador el documento configurado?`,
        'Sí',
        'No'
      );
      if (!answer) return;

      await _updateStatus(
        this.model.contractTemplateId,
        contractTemplateStatus.Borrador
      )
        .then((res) => {
          if (res.data) {
            this.model.statusId = res.data.statusId;
            this.model.statusName = res.data.statusDescription;
          }
          this.ShowToast(
            'Proceso exitoso.',
            'El documento ha sido cambiado a borrador exitosamente.',
            'success'
          );
        })
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error');
        });
    },
  },
};
</script>

<style>
.ql-align-center {
  text-align: center;
}

.ql-align-right {
  text-align: right;
}
.ql-align-left {
  text-align: left;
}
</style>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';

.dot {
  height: 16px;
  width: 16px;
  border-radius: 50%;
  display: inline-block;
}

.color-dot-gray {
  background-color: map-get($colors, 'gray');
}

.color-dot-green-light {
  background-color: map-get($colors, 'green-light');
}

.message-border {
  border: 1px solid;
  border-color: map-get($colors, 'gray-5');
  border-radius: 4px 4px 0px 0px;
  opacity: 1;
}

.was-Invalidated {
  border: 1px solid #ff0018 !important;
}
.scroll {
  max-height: 1000px;
  overflow-y: scroll;
}
.color-icon {
  color: #2db782 !important;
}
.container-html {
  border: 1px solid #e2e2e2;
  border-radius: 4px;
  padding: 11px;
}
.custom-icon-color {
  ::v-deep .border-icon {
    background: #fff 0 0 no-repeat padding-box;
    box-shadow: 0 3px 6px #00000029;
    border-radius: 50px;
    padding-top: 3px;
    padding-left: 4px;
    padding-right: 4px;
    margin-right: 5px;
    height: 25px;
    margin-top: -3px;
    display: flex;
  }
  ::v-deep .modal-title {
    background: transparent linear-gradient(90deg, #fff 0, #e8e8e8 100%) 0 0
      no-repeat padding-box;
    border-radius: 26px;
    padding: 4px 15px;
    font: 900 16px Lato;
    display: flex;
  }
}
</style>
